import React from "react";
import { Route, Routes } from "react-router-dom";
// Not lazy loaded. This is a critical element for acct create flow
import { AccountCreateContainer } from "./components/AccountCreateContainer";
import { withAuthenticationRequired } from "@auth0/auth0-react";

const LazyAccountListPage = React.lazy(
  () => import("./components/AccountListView")
);

export default withAuthenticationRequired(function AccountsRoutes() {
  return (
    <Routes>
      <Route index element={<LazyAccountListPage />} />
      <Route path="/create" element={<AccountCreateContainer />} />
    </Routes>
  );
});
